import styled from 'styled-components'
import {smallFont, mediumSmallFont} from '../../../../../theme/font-styles'
import {spacing} from '../../../../../theme/spacing'
import {BREAK_POINT} from '../create-chr-form.styled'

interface ContainerProps {
    isExtended: boolean
    width?: number | undefined
}

export const Container = styled.div<ContainerProps>`
    display: flex;
    width: ${(props) => ((props.width || 0) > BREAK_POINT ? '200px' : '250px')};
    height: 30px;
    border: 1px solid ${(props) => props.theme.colors.border.lowContrast};
    border-radius: 3px;
    background: ${(props) => props.theme.colors.background.default};
`

export const SearchIcon = styled.div`
    display: flex;
    align-items: center;
    padding: 0 ${spacing(1)} 0 ${spacing(1)};
    color: ${(props) => props.theme.colors.border.lowContrast};
`

export const CloseIcon = styled.button`
    display: flex;
    align-items: center;
    padding: 0;
    color: ${(props) => props.theme.colors.border.lowContrast};
    background: ${(props) => props.theme.colors.background.default};
    cursor: pointer;
    width: 20px;
    border: 0;
    &:hover {
        color: ${(props) => props.theme.colors.border.active};
    }
    :disabled {
        opacity: 0;
        cursor: default;
    }
`

export const SearchInput = styled.input<ContainerProps>`
    ${mediumSmallFont()};
    width: ${(props) => ((props.width || 0) > BREAK_POINT ? '155px' : '205px')};
    border: 0;
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:focus {
        outline: none;
        &::placeholder {
            opacity: 0;
        }
    }
    &::placeholder {
        ${smallFont()};
        color: ${(props) => props.theme.colors.text.deemphasize};
        text-align: center;
    }
`
